module.exports = __webpack_public_path__ + "static/media/btn2.7e4a76bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs/btn2.png
// module id = 405
// module chunks = 0